import {AllCommunityModule, ModuleRegistry, themeQuartz, TooltipModule} from 'ag-grid-community';
import {createGrid} from 'ag-grid-community';

// ! rename the function to align with the widget name
export const collectionsTable = async () => {
    const el = document.querySelector('.curious-collections-table');
    if (!el) return;

    // ------------------------------------------------------------
    const tableContainer = el.closest('.table-container');
    const scrollLeftIndicator = tableContainer?.querySelector('.table-scroll-indicator-left');
    const scrollRightIndicator = tableContainer?.querySelector('.table-scroll-indicator-right');
    const loadingStates = document.querySelectorAll('.table-container');
    ModuleRegistry.registerModules([AllCommunityModule, TooltipModule]);

    const url = `${window.apiUri}/collections`

    const urlParams = new URLSearchParams(window.location.search);

    const myParam = urlParams.get('f');
    let filter = "all";

    let visibleColumns = ['siglum', 'sonatas',]
    let invisibleColumns = ['rism', 'holding_library', 'editor_publisher', 'date']
    if (myParam === "manuscript") {
        filter = "manuscript"
        visibleColumns = ['siglum', 'rism', 'holding_library', 'sonatas',]
        invisibleColumns = ['date', 'editor_publisher']
    } else if (myParam === 'printed-edition') {
        filter = "printed-edition"
        visibleColumns = ['rism', 'siglum', 'editor_publisher', 'date', 'sonatas',]
        invisibleColumns = ['holding_library']
    }

    try {
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
        }
        const data = await response.json();
        if (!data || !data.length) {
            throw new Error('No data found')
            return;
        }

        const myTheme = themeQuartz.withParams({
            dataFontSize: 13,
            // wrapperBorder: false, 
        })

        const rowMaker = () => {
            let rows = data.map(collection => {
                let c = {}
                c.type = collection.type
                c.siglum = {
                    title: collection.siglum || collection.name,
                    slug: collection.slug
                }
                c.rism = collection.rism || 'N/A'
                c.sonatas = collection.sonata_count
                c.holding_library = collection.holding_library || 'N/A'
                c.editor_publisher = collection.editor_publisher || 'N/A'
                c.date = collection.date || 'Unknown'
                c.data = collection.gs_link || null

                return c
            })
            return rows
        }


        const isExternalFilterPresent = () => {
            // if ageType is not everyone, then we are filtering
            return filter !== "all";
        }

        const doesExternalFilterPass = (node) => {

            if (node.data) {
                switch (filter) {
                    case "manuscript" :
                        return node.data.type === 'manuscript';
                    case "printed-edition" :
                        return node.data.type === 'printed-edition';
                    default:
                        return true;
                }
            }
            return true;
        }

        const externalFilterChanged = (newValue) => {
            filter = newValue
            if (filter === "manuscript") {
                // Manuscript
                visibleColumns = ['siglum', 's_title', 'rism', 'sonatas', 'holding_library', 'holding_library']
                invisibleColumns = ['date', 'editor_publisher']

            } else if (filter === 'printed-edition') {
                // Printed Editions
                visibleColumns = ['siglum', 's_title', 'rism', 'sonatas', 'holding_library', 'editor_publisher', 'date']
                invisibleColumns = ['holding_library']
            } else {
                // Fallback and 'ALL'
                visibleColumns = ['siglum', 'sonatas',]
                invisibleColumns = ['rism', 'holding_library', 'editor_publisher', 'date']
            }

            collectionsGrid.setColumnsVisible(visibleColumns, true)
            collectionsGrid.setColumnsVisible(invisibleColumns, false)

            collectionsGrid.onFilterChanged()
            sizeColumnsToBestFit(collectionsGrid)
        }

        const filterButtons = document.querySelectorAll('.filters button')
        filterButtons.forEach(button => {
            if (button.getAttribute('value') === filter) {
                button.classList.add('active')
            }

            button.addEventListener('click', (e) => {
                e.preventDefault()

                filterButtons.forEach(b => b.classList.remove('active'))
                button.classList.add('active')

                externalFilterChanged(button.getAttribute('value'))
            })
        });

        const tmp_rism_link = "https://rism.online/sources/";
        const helpfulHeaderMinWidths = {
            siglum: 160,
            rism: 110,
            holding_library: 160,
            editor_publisher: 170,
            date: 90,
            sonatas: 160,
            data: 170,
        };
        const cappedWidthColumns = ['holding_library', 'editor_publisher'];

        const findHorizontalScrollViewport = () => {
            return myGridElement.querySelector('.ag-body-horizontal-scroll-viewport')
                || myGridElement.querySelector('.ag-center-cols-viewport');
        };

        const setIndicatorState = (indicator, enabled) => {
            if (!indicator) {
                return;
            }

            indicator.setAttribute('aria-hidden', enabled ? 'false' : 'true');
            indicator.setAttribute('tabindex', enabled ? '0' : '-1');
            indicator.disabled = !enabled;
        };

        const scrollByColumn = (direction) => {
            const scrollViewport = findHorizontalScrollViewport();
            if (!scrollViewport) {
                return;
            }

            const displayedColumns = collectionsGrid.getAllDisplayedColumns();
            if (!displayedColumns.length) {
                return;
            }

            const viewportLeft = scrollViewport.scrollLeft;
            const viewportRight = viewportLeft + scrollViewport.clientWidth;
            const nextColumn = direction === 'left'
                ? [...displayedColumns].reverse().find((column) => column.getLeft() < viewportLeft - 4)
                : displayedColumns.find((column) => column.getLeft() + column.getActualWidth() > viewportRight + 4);

            if (nextColumn) {
                collectionsGrid.ensureColumnVisible(nextColumn, direction === 'left' ? 'start' : 'end');
            }
        };

        const updateScrollIndicator = () => {
            if (!tableContainer) {
                return;
            }

            const scrollViewport = findHorizontalScrollViewport();
            if (!scrollViewport) {
                tableContainer.classList.remove('has-horizontal-overflow', 'can-scroll-left', 'can-scroll-right');
                setIndicatorState(scrollLeftIndicator, false);
                setIndicatorState(scrollRightIndicator, false);
                return;
            }

            const maxScrollLeft = scrollViewport.scrollWidth - scrollViewport.clientWidth;
            const hasHorizontalOverflow = maxScrollLeft > 2;
            const canScrollLeft = scrollViewport.scrollLeft > 2;
            const canScrollRight = scrollViewport.scrollLeft < maxScrollLeft - 2;

            tableContainer.classList.toggle('has-horizontal-overflow', hasHorizontalOverflow);
            tableContainer.classList.toggle('can-scroll-left', hasHorizontalOverflow && canScrollLeft);
            tableContainer.classList.toggle('can-scroll-right', hasHorizontalOverflow && canScrollRight);
            setIndicatorState(scrollLeftIndicator, hasHorizontalOverflow && canScrollLeft);
            setIndicatorState(scrollRightIndicator, hasHorizontalOverflow && canScrollRight);
        };

        const bindScrollIndicator = () => {
            const scrollViewport = findHorizontalScrollViewport();
            if (!scrollViewport || scrollViewport.dataset.scrollIndicatorBound === 'true') {
                updateScrollIndicator();
                return;
            }

            scrollViewport.dataset.scrollIndicatorBound = 'true';
            scrollViewport.addEventListener('scroll', updateScrollIndicator, {passive: true});
            updateScrollIndicator();
        };

        const sizeColumnsToBestFit = (gridApi) => {
            window.requestAnimationFrame(() => {
                const displayedColumns = gridApi.getAllDisplayedColumns();
                const gridWidth = myGridElement.clientWidth;

                if (!displayedColumns.length || !gridWidth) {
                    return;
                }

                // Size from cell contents first and let headers truncate slightly if needed.
                gridApi.autoSizeColumns(displayedColumns, true);

                const autosizedColumns = displayedColumns.map((column) => ({
                    column,
                    colId: column.getColId(),
                    contentWidth: column.getActualWidth(),
                    minWidth: helpfulHeaderMinWidths[column.getColId()] || 100,
                }));

                const targetColumns = autosizedColumns.map((column) => ({
                    ...column,
                    width: Math.max(column.contentWidth, column.minWidth),
                }));

                const maxWrappedColumnWidth = Math.floor(gridWidth * 0.20);
                targetColumns.forEach((column) => {
                    if (cappedWidthColumns.includes(column.colId)) {
                        column.width = Math.min(column.width, maxWrappedColumnWidth);
                    }
                });

                const totalTargetWidth = targetColumns.reduce((total, column) => {
                    return total + column.width;
                }, 0);

                if (totalTargetWidth >= gridWidth) {
                    gridApi.setColumnWidths(targetColumns.map((column) => ({
                        key: column.column,
                        newWidth: column.width,
                    })));
                    bindScrollIndicator();
                    return;
                }

                const resizedColumns = [];
                let usedWidth = 0;
                const extraWidth = gridWidth - totalTargetWidth;

                targetColumns.forEach((column, index) => {
                    const remainingWidth = targetColumns
                        .slice(index + 1)
                        .reduce((total, nextColumn) => total + nextColumn.width, 0);

                    const proportionalExtra = Math.floor((column.width / totalTargetWidth) * extraWidth);
                    let nextWidth = column.width + proportionalExtra;

                    if (index === targetColumns.length - 1) {
                        nextWidth = gridWidth - usedWidth;
                    } else {
                        const maxAllowedWidth = gridWidth - usedWidth - remainingWidth;
                        nextWidth = Math.min(nextWidth, maxAllowedWidth);
                    }

                    usedWidth += nextWidth;
                    resizedColumns.push({
                        key: column.column,
                        newWidth: nextWidth,
                    });
                });

                gridApi.setColumnWidths(resizedColumns);
                bindScrollIndicator();
            });
        };


        const gridOptions = {
            theme: myTheme,
            domLayout: 'autoHeight',
            tooltipShowDelay: 0,
            tooltipHideDelay: 2000,
            tooltipShowMode: 'whenTruncated',
            pagination: true,
            paginationPageSize: 30,
            paginationPageSizeSelector: [10, 30, 50, 100],
            defaultColDef: {
                resizable: true,
            },

            // autoSizeStrategy: {
            //     type: 'fitGridWidth',
            //     defaultMinWidth: 150,
            //     columnLimits: [{
            //         colId: 'siglum',
            //         minWidth: 200
            //     }]
            // },

            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,


            // Column Definitions: Defines the columns to be displayed.
            columnDefs: [
                {field: 'type', headerName: 'Type', headerTooltip: 'Type', filter: 'agTextColumnFilter', hide: true,},
                {
                    field: 'siglum',
                    pinned: 'left',
                    headerName: 'Siglum',
                    headerTooltip: 'Siglum',
                    width: 220,
                    filter: true,
                    cellStyle: {fontWeight: 'bold'},
                    valueFormatter: params => params.value.title,
                    cellRenderer: params => {
                        return `
                    <div class="title-cell">
                        <a href="/collection/${params.value.slug}" class="ag-btn">
                        ${params.value.title}
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="6" fill="#EB131B"/>
                                <path d="M5 8.25L8 6.125L5 4" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                    `
                    },
                },

                // TODO: include a link to the library - manufactured url from the RISM
                {
                    field: 'rism', headerName: 'RISM', headerTooltip: 'RISM', filter: true,
                    cellClass: params => {
                        return params.value === 'N/A' ? 'greyed-out' : '';
                    },
                    cellRenderer: params => {
                        return params.value === 'N/A' ? '' :
                            params.value &&
                            `
                            <a href='${tmp_rism_link}${params.value}' target='_blank' class="rism-link">${params.value}</a>
                            `;
                    }
                },
                {
                    field: 'holding_library', headerName: 'Holding Library', headerTooltip: 'Holding Library', filter: true,
                    wrapText: true,
                    autoHeight: true,
                    cellClass: params => {
                        return params.value === 'N/A' ? 'greyed-out' : '';
                    }
                },
                {
                    field: 'editor_publisher', headerName: 'Editor/Publisher', headerTooltip: 'Editor/Publisher', filter: true, wrapText: true, autoHeight: true, cellClass: params => {
                        return params.value === 'N/A' ? 'greyed-out' : '';
                    },
                },
                {
                    field: 'date', headerName: 'Date', headerTooltip: 'Date', filter: true, cellClass: params => {
                        return params.value === 'Unknown' ? 'greyed-out' : '';
                    },
                },
                {
                    field: 'sonatas', headerName: 'No. of Sonatas', headerTooltip: 'No. of Sonatas', filter: true, width: 180, cellClass: params => {
                        return params.value === 'N/A' ? 'greyed-out' : '';
                    },
                },
                {
                    field: 'data', headerName: 'Full Variant Analysis', headerTooltip: 'Full Variant Analysis', filter: true, width: 280, cellRenderer: params => {
                        return params.value && `
                    <div class="link-cell">
                        <a href="${params.value}" class="ag-btn" target="_blank" rel="noopener noreferrer">
                            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81444 18.8329L2.87287 20.7063C3.09281 21.1008 3.40894 21.4107 3.78009 21.6361C4.84316 20.2532 5.58316 19.1921 6.00009 18.4526C6.42322 17.7022 6.94325 16.5284 7.56019 14.9312C5.89744 14.7069 4.63744 14.5947 3.78019 14.5947C2.95737 14.5947 1.69731 14.7069 0 14.9312C0 15.3678 0.109969 15.8044 0.329906 16.1989L1.81444 18.8329Z" fill="#0066DA"/>
                                <path d="M20.2199 21.6361C20.5912 21.4107 20.9073 21.1008 21.1271 20.7064L21.567 19.9317L23.6702 16.1989C23.8861 15.813 23.9998 15.376 24 14.9312C22.2928 14.7069 21.0351 14.5947 20.2269 14.5947C19.3582 14.5947 18.1004 14.7069 16.4536 14.9312C17.0632 16.5371 17.5764 17.7109 17.9932 18.4526C18.4134 19.2009 19.1557 20.262 20.2199 21.6361Z" fill="#EA4335"/>
                                <path d="M12.0003 7.04298C13.2303 5.52072 14.078 4.34691 14.5433 3.52154C14.918 2.85693 15.3304 1.79577 15.7804 0.33807C15.4092 0.11269 14.9832 0 14.5433 0H9.45734C9.01746 0 8.59146 0.126812 8.22021 0.33807C8.79271 2.00988 9.27846 3.19967 9.67746 3.90745C10.1185 4.68965 10.8927 5.73483 12.0003 7.04298Z" fill="#00832D"/>
                                <path d="M16.4401 14.9312H7.56027L3.78027 21.6361C4.15134 21.8614 4.57743 21.9741 5.0173 21.9741H18.9831C19.4229 21.9741 19.8491 21.8473 20.2202 21.636L16.4401 14.9312Z" fill="#2684FC"/>
                                <path d="M12.0001 7.04295L8.22009 0.338135C7.84884 0.563515 7.53272 0.87334 7.31278 1.2678L0.329906 13.6634C0.114024 14.0493 0.000298266 14.4863 0 14.9311H7.56019L12.0001 7.04295Z" fill="#00AC47"/>
                                <path d="M20.1788 7.46565L16.6872 1.2678C16.4674 0.87334 16.1512 0.563515 15.78 0.338135L12 7.04304L16.4398 14.9312H23.9863C23.9863 14.4945 23.8763 14.058 23.6564 13.6635L20.1788 7.46565Z" fill="#FFBA00"/>
                            </svg>
                            &nbsp;Download
                        </a>
                    </div>
                    `
                    }
                },

            ],


            // Row Data: The data to be displayed.
            rowData: rowMaker(),
            onFirstDataRendered: (params) => {
                sizeColumnsToBestFit(params.api);
                bindScrollIndicator();
            },
            onGridSizeChanged: (params) => {
                sizeColumnsToBestFit(params.api);
                updateScrollIndicator();
            },

        };
        // Your Javascript code to create the Data Grid
        const myGridElement = document.querySelector('#collections-ag-table');
        const collectionsGrid = createGrid(myGridElement, gridOptions);

        scrollLeftIndicator?.addEventListener('click', () => scrollByColumn('left'));
        scrollRightIndicator?.addEventListener('click', () => scrollByColumn('right'));


        const search = document.querySelector('#filter-text-box');

        const onFilterTextBoxChanged = () => {
            collectionsGrid.setGridOption("quickFilterText", search.value);
        }
        search.addEventListener('input', onFilterTextBoxChanged);


        if (visibleColumns.length > 0) {
            collectionsGrid.setColumnsVisible(visibleColumns, true)
            collectionsGrid.setColumnsVisible(invisibleColumns, false)
            sizeColumnsToBestFit(collectionsGrid)
        }
        bindScrollIndicator()
        loadingStates.forEach(container => container.classList.remove('loading'))

    } catch (error) {
        console.error(error.message)
    }


    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}
